import { render, staticRenderFns } from "./PesquisaAtoInfralegalShow.vue?vue&type=template&id=74be916a&scoped=true"
import script from "./PesquisaAtoInfralegalShow.vue?vue&type=script&lang=js"
export * from "./PesquisaAtoInfralegalShow.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAtoInfralegalShow.vue?vue&type=style&index=0&id=74be916a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be916a",
  null
  
)

export default component.exports